module.exports = function() {
  return new Worker(__webpack_public_path__ + "67df0efba89e1821577c.worker.js");
};


// WEBPACK FOOTER //
// ./src/modules/matrix.worker.js